import React, { useState, useEffect, useRef, useContext } from "react";
import PantallaMesas from "./../Componentes/PantallaMesas";
import moment from "moment";
import { reactLocalStorage } from "reactjs-localstorage";
import { Decimal } from "decimal.js";
import "./../Componentes/www/layout.css";
import "./../Componentes/www/factura.css";
import { ToastContainer } from "react-custom-alert";
import useScanDetection from "use-scan-detection";
import { LOGO_RESTAURANTE } from "./../Componentes/Image";
import StoreContext from "./../Componentes/Store/Context";
import { validate } from "react-email-validator";
import { STATES_FAC_FACTURA } from "../Componentes/States";
import { EnviadoCocinaModal, ModalReporteZ, ListaOrden, ListaClienteModal, ClienteModal, PagarModal, ListaItemModal, EnviadoModal, RucModal, AnulacionModal, ListaFacModal, ListaCotizacion, ListaCreditos, NUMEROModal, OPENCASHDRAWERModal } from "./../Componentes/Modal";
import {
  get_re_retencion,
  get_articulo_detail,
  get_list_items_restaurante,
  get_cli_cliente_restaurant,
  get_ord_ordenes_ord,
  get_ord_ordenes_list,
  put_entregado_orden,
  put_ordd_detalle,
  post_ordd_detalle,
  put_orden_detalle,
  put_delete_orden_detalle,
  get_ord_ordenes_mesas,
  get_ord_ordenes,
  get_cr_credito_detalle_byIdentificador,
  print_recibo_pago,
  post_crp_credito_pago,
  get_cr_credito_detalle,
  get_crp_credito_pago,
  get_cr_credito,
  get_cli_cliente,
  get_articulo_by_code,
  get_frm_pago,
  post_cli_cliente,
  get_list_items,
  get_cot_cotizacion_list,
  get_cot_cotizacion_fac,
  get_report_x,
  print_report_x,
  get_list_anulacion,
  get_list_fac_imprimir,
  get_list_itemsFactura,
  get_frm_pago_imprimir_fac,
  delete_crp_credito_pago,
  print_recibo_pagoCopia,
  get_gr_garantia,
  consultar_ruc,
  put_delete_orden_by_ord,
  open_cashDrawer,
  put_cli_cliente_sts,
  imgURLocalImage,
  put_check_orden,
  get_series_by_articulo,
  print_recibo_cocina,
  put_comanda,
  put_comanda_info,
  put_para_llevar,
  put_ord_nombre_mesa,
  get_facturas_hka_pendientes,
  consultar_estadoDocumento,
} from "../Componentes/Services";
import { COPIA_FACTURA, GUARDAR_FACTURA, ANULAR_FACTURA, PUT_CLIENTE, GUARDAR_ORDEN_RESTAURANTE, GUARDAR_ORDEN_NORMAL, NC_FACTURA, MONEY_ROUND, CALCULAR_DESCUENTO_FACTURA, GET_FORMAS_PAGO, CONVERTIR_ORDEN_A_FACTURA } from "./../Componentes/Util";
import { DATATABLE_RESTAURANTE } from "../Componentes/Datatables";
import PantallaFactura from "../Componentes/PantallaFactura";

export const Factura = () => {
  var enableTab = true;
  var descuento = new Decimal(0);
  var subtotal = new Decimal(0);
  var itbms = new Decimal(0);
  var total = new Decimal(0);
  const { dataCompania, cajaData, usr_a_costo, usr_print, usr_id, usr_nombre, usr_precio, usr_modo_tableta, usr_perfil, com_suc_emisor, usr_sucursal, setToken, quitToken, setdataFacturaLocalStorage } = useContext(StoreContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElSerie, setAnchorElSerie] = React.useState(null);
  const open = Boolean(anchorEl);
  const openSerie = Boolean(anchorElSerie);
  const [error, setError] = useState("");
  const inputUpc = useRef(null);
  const inputCantidad = useRef(null);
  const [errorCliente, setErrorCliente] = useState("");
  const [errorAnulacion, setErrorAnulacion] = useState("");
  const [errorRuc, setErrorRuc] = useState("");
  const [error_upc, setError_upc] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOpenDetailItem, SetOpenDetailItem] = useState(false);
  const [isOpenReporteZ, SetOpenReporteZ] = useState(false);
  const [dataReporteZ, setDataReporteZ] = useState([]);
  const [isModalPagar, setModalPagar] = useState(false);
  const [isModalEnviadoCocina, setModalCocinaEnviado] = useState(false);
  const [isModalAnular, setModalAnular] = useState(false);
  const [isModalCopiaF, setModalCopiaF] = useState(false);
  const [isModalCotizacion, setModalCotizacion] = useState(false);
  const [isModalOrden, setModalOrden] = useState(false);
  const [isModalCreditos, setModalCreditos] = useState(false);
  const [isModalEnviado, setModalEnviado] = useState(false);
  const [isModalCliente, setModalCliente] = useState(false);
  const [isAddmodalCliente, setModalAddCliente] = useState(false);
  const [isAddmodalItems, setModalItems] = useState(false);
  const [isDetailItem, setDetailItems] = useState(false);
  const [dataCliente, setDataCliente] = useState([]);
  const [dataGarantia, setDataGarantia] = useState([]);
  const [dataCreditos, setDataCreditos] = useState([]);
  const [dataCreditosDetalle, setDataCreditosDetalle] = useState([]);
  const [dataCreditosPago, setDataCreditosPago] = useState([]);
  const [dataCreditosFactura, setDataCreditosFactura] = useState([]);
  const [dataFormaPago, setFormaPago] = useState([]);
  const [dataItems, setDataItems] = useState([]);
  const [dataSeries, setDataSeries] = useState([]);
  const [dataCategoria, setDataCategoria] = useState([]);
  const [dataOrdenesDetalle, setDataOrdenesDetalle] = useState([]);
  const [dataMesas, setDataMesas] = useState([]);
  const [isResEditing, setResEditing] = useState(false);
  const [formRestaurante, setFormRestaurante] = useState(STATES_FAC_FACTURA({ staneName: "formRestaurante", usr_id }));
  const [formSerie, setFormSerie] = useState([]);
  const [dataListCopia, setDataListFCopia] = useState([]);
  var [dataFacturaDetalle, setOBJFacturaDetalle] = useState([]);
  const [dataRetencion, setDataRetencion] = useState([]);
  const [basicModalEditCliente, setBasicModalEditCliente] = useState(false);
  const [dataListPago, setDatalistpago] = useState([]);
  const [dataListAnulacion, setDatalistAnulacion] = useState([]);
  const [dataListCotizacion, setDataListCotizacion] = useState([]);
  const [dataBodyCredito, setDataBodyCredito] = useState([]);
  const [isModalRuc, setModalRuc] = useState(false);
  const [isModalNumber, setModalNumber] = useState(false);
  const [isModaCashDrawer, setModalCash] = useState(false);
  const [flagCalendar, setOpenFlagCalendar] = useState(0);
  const [state, setState] = useState(STATES_FAC_FACTURA({ staneName: "selection", usr_id }));
  const [isPrinting, setPrintI] = useState(false);
  const [dataListOrden, setDataListOrden] = useState([]);
  const [formGarantia, setFormGarantia] = useState({ gr_name: "", gr_descripcion: "" });
  const [formDetailItem, setFormDetailItem] = useState(STATES_FAC_FACTURA({ staneName: "formDetailItem", usr_id }));
  const [formAnulacion, setFormAnulacion] = useState(STATES_FAC_FACTURA({ staneName: "formAnulacion", usr_id }));
  const [formRuc, setFormRuc] = useState(STATES_FAC_FACTURA({ staneName: "formRuc", usr_id }));
  const [dataRuc, setDataRuc] = useState(STATES_FAC_FACTURA({ staneName: "dataRuc", usr_id }));
  const [formListPago, setFormListPago] = useState(STATES_FAC_FACTURA({ staneName: "formListPago", usr_id }));
  const [dataCompania_f, setdataCompania_f] = useState(STATES_FAC_FACTURA({ staneName: "dataCompania_f", usr_id }));
  const [formClientes, setFormClientes] = useState(STATES_FAC_FACTURA({ staneName: "formClientes", usr_id }));
  const [formPagoCredito, setFormPagoCredito] = useState(STATES_FAC_FACTURA({ staneName: "formPagoCredito", usr_id }));
  const [formDropDownCliente, setFormDropDownCliente] = useState(STATES_FAC_FACTURA({ staneName: "formDropDownCliente", usr_id }));
  const [formDropDownFPago, setFormDropDownFPago] = useState(STATES_FAC_FACTURA({ staneName: "formDropDownFPago", usr_id }));
  const [formCredito, setFormCredito] = useState(STATES_FAC_FACTURA({ staneName: "formCredito", usr_id }));
  const [formPrecio, setFormPrecio] = useState(STATES_FAC_FACTURA({ staneName: "formPrecio", usr_id }));
  const [formFactura, setFormFactura] = useState(STATES_FAC_FACTURA({ staneName: "formFactura", usr_id }));
  const [formFacturaDetalle, setFormFacturaDetalle] = useState(STATES_FAC_FACTURA({ staneName: "formFacturaDetalle", usr_id }));
  const [formRetencion, setFormRetencion] = useState(STATES_FAC_FACTURA({ staneName: "formRetencion", usr_id }));

  const handleClickPrices = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickSeries = (event) => {
    setAnchorElSerie(event.currentTarget);
    setError_upc("");
  };

  const includes_price = () => {
    setFormFacturaDetalle({ ...formFacturaDetalle, fcd_precio: new Decimal(formFacturaDetalle.fcd_precio).dividedBy(new Decimal(formFacturaDetalle.art_itbm_venta).plus(1)).toFixed(6) });
  };

  const handleClosePrices = () => {
    setAnchorEl(null);
  };

  useScanDetection({
    onComplete: (code) => {
      if (!isModalPagar && !isModalCopiaF && !isModalCotizacion && !isModalCreditos && !isModalOrden && !isModalCliente && !isAddmodalCliente && !isAddmodalItems && !isModalAnular) {
        if (document.activeElement !== document.getElementById("art_upc") && document.activeElement !== document.getElementById("fcd_cantidad") && document.activeElement !== document.getElementById("art_descripcion")) {
          if (enableTab === false) {
            setTimeout(() => {
              setError_upc("");
              fetchArticuloByUpc({ art_upc: code, barcode: true, modalItem: false });
              setFormFacturaDetalle({ ...formFacturaDetalle, art_upc: code });
            }, 300);
          }
        }
      }
    },
    minLength: 3,
  });

  async function fetchReRetencion() {
    // if (usr_perfil !== "3") {
    var response = await get_re_retencion();
    setDataRetencion(response);
    // }
  }

  async function fetchMesas({ form }) {
    if (usr_perfil === "3") {
      var response = await get_ord_ordenes_mesas();
      var mesas = [];
      var result = [];
      var hashMesas = {};

      mesas = response.filter((o) => (hashMesas[o.ord_mesa] || o.ord_mesa === null ? false : (hashMesas[o.ord_mesa] = true)));
      result = mesas.map((data1) => {
        var flag = false;
        response.map((data2) => {
          if (data1.ord_mesa === data2.ord_mesa && data2.ordd_entregado === "0") {
            flag = true;
          }
        });
        if (flag)
          return {
            ordd_identificador: data1.ordd_identificador,
            ord_mesa: data1.ord_mesa,
            ord_fecha: data1.ord_fecha,
            ord_info_comanda: data1.ord_info_comanda,
            ord_para_llevar: data1.ord_para_llevar,
            ordd_entregado: "0",
            ord_nombre_mesa: data1.ord_nombre_mesa,
          };
        else
          return {
            ordd_identificador: data1.ordd_identificador,
            ord_fecha: data1.ord_fecha,
            ord_mesa: data1.ord_mesa,
            ord_info_comanda: data1.ord_info_comanda,
            ord_para_llevar: data1.ord_para_llevar,
            ordd_entregado: "1",
            ord_nombre_mesa: data1.ord_nombre_mesa,
          };
      });

      setDataMesas(result);
      setFormRest({ data: result, form });
    }
  }

  async function fetchGarantia() {
    var response = await get_gr_garantia();
    setDataGarantia(response);
  }

  async function fetchOrdenes({ res_id, form }) {
    var defaultCliente = dataCliente.find((data) => {
      if (data.cli_id === "16") {
        return data;
      }
    });
    setFormClientes(defaultCliente);
    var response = await get_ord_ordenes(res_id);

    if (response[0] !== undefined) {
      setResEditing(true);
    } else {
      setResEditing(false);
    }

    setDataOrdenesDetalle(response);
    const dataFacturaDesdeOrden = response.map(CONVERTIR_ORDEN_A_FACTURA);
    setdataFacturaLocalStorage({
      dataFacturaDetallePr: {
        dataFacturaDetalle: dataFacturaDesdeOrden,
        formClientes: defaultCliente,
        dataListPago,
      },
    });

    fetchMesas({ form });
  }

  async function fetchCotizacionList() {
    var response = await get_cot_cotizacion_list({ usr_sucursal });
    setDataListCotizacion(response);
    setModalCotizacion(true);
  }
  async function fetchOrdenesList() {
    var response = await get_ord_ordenes_list({ isRestaurant: usr_perfil === "4" ? "1" : "0", usr_sucursal });
    setDataListOrden(response);
    setModalOrden(true);
  }
  async function fetchCrCredito() {
    var response = await get_cr_credito({ usr_sucursal });
    setDataCreditos(response);
  }
  async function fetchCrCreditoDetalle({ crd_cliente }) {
    var response = await get_cr_credito_detalle(crd_cliente);
    setDataCreditosDetalle(response);
  }
  async function fetchCreditoDetalleIdentificador({ crd_fac_identificador }) {
    var response = await get_cr_credito_detalle_byIdentificador(crd_fac_identificador);
    setFormPagoCredito({ ...formPagoCredito, crd_fecha: response[0].fac_fecha, crd_monto: response[0].crd_monto_c, crp_monto: response[0].crp_monto_p, fac_id: response[0].fac_id, fac_identificador: response[0].fac_identificador });
  }
  async function fetchCreditoPago({ crd_fac_identificador }) {
    var response = await get_crp_credito_pago(crd_fac_identificador);
    setDataCreditosPago(response.pago);
    setDataCreditosFactura(response);
  }
  async function fetchCreditoPagoPrint({ crd_fac_identificador, recibe_number, totalValorRecibido, Objfactura_fpago, ObjFPago, montoEntregado }) {
    var response = await get_crp_credito_pago(crd_fac_identificador);
    var resultCP = response.pago.map((data) => {
      return {
        crp_id: data.crp_id.toString().padStart(10, "0"),
        crp_fecha: moment(data.crp_fecha).format("YYYY-MM-DD"),
        crp_monto: data.crp_monto,
      };
    });
    var crp_monto_p = (Number(formPagoCredito.crp_monto) + Number(totalValorRecibido)).toFixed(2);
    var bodyRecibo = {
      dataCompany: dataCompania,
      fcfp_factura_fpago: Objfactura_fpago,
      ObjFPago,
      totalValorRecibido: totalValorRecibido.toFixed(2),
      formPagoCredito: {
        cli_ruc: formPagoCredito.cli_ruc,
        cli_name: formPagoCredito.cli_name,
        fac_id: formPagoCredito.fac_id.toString().padStart(10, "0"),
      },
      recibo_number: recibe_number,
      dataCreditosPago: resultCP,
      crp_monto: Number(formPagoCredito.crd_monto).toFixed(2),
      crp_monto_p,
      saldo: (Number(formPagoCredito.crd_monto) - Number(crp_monto_p)).toFixed(2),
      montoEntregado: montoEntregado.toFixed(2),
    };

    print_recibo_pago(bodyRecibo);
  }
  async function fetchCreditoPagoPrintCopia({ type }) {
    var response = dataCreditosPago;
    var resultCP = response.map((data) => {
      return {
        crp_id: data.crp_id.toString().padStart(10, "0"),
        crp_fecha: moment(data.crp_fecha).format("YYYY-MM-DD"),
        crp_monto: data.crp_monto,
      };
    });

    var bodyRecibo = {
      dataCreditosFactura: dataCreditosFactura,
      dataCompany: dataCompania,
      formPagoCredito: {
        cli_ruc: formPagoCredito.cli_ruc,
        cli_name: formPagoCredito.cli_name,
        cli_telefono: formPagoCredito.cli_telefono,
        fac_id: formPagoCredito.fac_id.toString().padStart(10, "0"),
      },
      dataCreditosPago: resultCP,
      crp_monto: Number(formPagoCredito.crd_monto).toFixed(2),
      crp_monto_p,
      saldo: (Number(formPagoCredito.crd_monto) - Number(crp_monto_p)).toFixed(2),
      isCopia: true,
    };

    if (type === "pdf") {
      setDataBodyCredito(bodyRecibo);
      setPrintI(true);
    } else {
      print_recibo_pagoCopia(bodyRecibo);
    }
  }
  async function fetchCliente({ is_saving }) {
    var response = [];
    if (usr_perfil === "3") {
      response = await get_cli_cliente_restaurant();
    } else {
      response = await get_cli_cliente(usr_sucursal);
    }
    setDataCliente(response);
    setBasicModalEditCliente(false);
    setModalAddCliente(false);
    if (!is_saving) {
      setFormClientesBlank();
    }
  }
  async function fetchListFacImprimir() {
    var response = await get_list_fac_imprimir({ fac_sucursal: dataCompania.com_id });
    setDataListFCopia(response);
  }
  async function fetchListAnulacion() {
    var response = await get_list_anulacion({ fac_sucursal: dataCompania.com_id });
    setDatalistAnulacion(response);
  }

  function fetchReportX() {
    SetOpenReporteZ(true);
    fetchReportXResult({ startDate: moment(new Date()).format("YYYY-MM-DD"), endDate: moment(new Date()).format("YYYY-MM-DD") });
    setState([
      {
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        key: "selection",
      },
    ]);
  }
  function openCashDrawer() {
    open_cashDrawer();
    setModalCash(false);
  }

  function printReportX() {
    print_report_x(dataReporteZ);
  }

  async function fetchReportXResult({ startDate, endDate }) {
    var response = await get_report_x({ startDate: moment(startDate).format("YYYY-MM-DD"), endDate: moment(endDate).format("YYYY-MM-DD"), fac_caja: cajaData.caj_id, fac_vendedor: usr_id, sucursal: usr_sucursal });

    setDataReporteZ(response);
    SetOpenReporteZ(true);
  }
  async function fetch_list_items() {
    var response = [];
    if (usr_perfil === "3" || usr_perfil === "4") response = await get_list_items_restaurante(usr_sucursal);
    else response = await get_list_items(usr_sucursal);

    setDataItems(response);
    var categoria = [];
    var hashCategoria = {};
    categoria = response.filter((o) => (hashCategoria[o.art_categoria] || o.art_categoria === null ? false : (hashCategoria[o.art_categoria] = true)));
    setDataCategoria(categoria);
  }
  async function fetchFormaPago() {
    var response = await get_frm_pago();
    setFormaPago(response);
  }
  async function fetchOrdenByIdentificador({ ordd_identificador, ord_mesa, res_nombre }) {
    var response = await get_ord_ordenes_ord({ ordd_identificador });
    setOBJFacturaDetalle(response.items);
    setdataFacturaLocalStorage({
      dataFacturaDetallePr: {
        dataFacturaDetalle: response.items,
        formClientes: {
          cli_id: response.cliente[0].cli_id,
          cli_suc: response.cliente[0].cli_suc,
          cli_sts: response.cliente[0].cli_sts,
          cli_nombre: response.cliente[0].cli_nombre,
          cli_direccion: response.cliente[0].cli_direccion,
          cli_telefono: response.cliente[0].cli_telefono,
          cli_telefono2: response.cliente[0].cli_telefono2,
          cli_ruc: response.cliente[0].cli_ruc,
          cli_dv: response.cliente[0].cli_dv,
          cli_email: response.cliente[0].cli_email,
        },
        dataListPago,
      },
    });
    setFormClientes({
      cli_id: response.cliente[0].cli_id,
      cli_suc: response.cliente[0].cli_suc,
      cli_sts: response.cliente[0].cli_sts,
      cli_nombre: response.cliente[0].cli_nombre,
      cli_direccion: response.cliente[0].cli_direccion,
      cli_telefono: response.cliente[0].cli_telefono,
      cli_telefono2: response.cliente[0].cli_telefono2,
      cli_ruc: response.cliente[0].cli_ruc,
      cli_dv: response.cliente[0].cli_dv,
      cli_email: response.cliente[0].cli_email,
      re_id: response.cliente[0].re_id,
      re_desc: response.cliente[0].re_desc,
      re_porc: response.cliente[0].re_porc,
      re_codigo: response.cliente[0].re_codigo,
    });
    setFormRestaurante({ ...formRestaurante, current_ord_identificador: ordd_identificador, res_mesa_selected: ord_mesa, res_nombre });
    setModalOrden(false);
  }
  async function fetchCotizacionByIdentificador({ cot_identificador }) {
    var response = await get_cot_cotizacion_fac({ cot_identificador });
    setOBJFacturaDetalle(response.items);
    setdataFacturaLocalStorage({
      dataFacturaDetallePr: {
        dataFacturaDetalle: response.items,
        formClientes: {
          cli_id: response.cliente[0].cli_id,
          cli_suc: response.cliente[0].cli_suc,
          cli_sts: response.cliente[0].cli_sts,
          cli_nombre: response.cliente[0].cli_nombre,
          cli_direccion: response.cliente[0].cli_direccion,
          cli_telefono: response.cliente[0].cli_telefono,
          cli_telefono2: response.cliente[0].cli_telefono2,
          cli_exento: response.cliente[0].cli_exento,
          cli_tipo_clienteFE: response.cliente[0].cli_tipo_clienteFE,
          cli_ruc: response.cliente[0].cli_ruc,
          cli_dv: response.cliente[0].cli_dv,
          cli_email: response.cliente[0].cli_email,
        },
        dataListPago,
      },
    });
    setFormClientes({
      cli_id: response.cliente[0].cli_id,
      cli_suc: response.cliente[0].cli_suc,
      cli_sts: response.cliente[0].cli_sts,
      cli_nombre: response.cliente[0].cli_nombre,
      cli_direccion: response.cliente[0].cli_direccion,
      cli_telefono: response.cliente[0].cli_telefono,
      cli_telefono2: response.cliente[0].cli_telefono2,
      cli_ruc: response.cliente[0].cli_ruc,
      cli_dv: response.cliente[0].cli_dv,
      cli_email: response.cliente[0].cli_email,
      cli_exento: response.cliente[0].cli_exento,
      cli_tipo_clienteFE: response.cliente[0].cli_tipo_clienteFE,
      re_id: response.cliente[0].re_id,
      re_desc: response.cliente[0].re_desc,
      re_porc: response.cliente[0].re_porc,
      re_codigo: response.cliente[0].re_codigo,
    });

    setFormGarantia({
      gr_name: response.garantia[0].cot_garantia_name,
      gr_descripcion: response.garantia[0].cot_garantia,
    });
    setModalCotizacion(false);
  }
  async function select_detail_articulo({ row }) {
    var response = await get_articulo_detail(row.art_id);
    setFormDetailItem({
      art_categoria: row.art_categoria,
      art_descripcion: row.art_descripcion,
      art_id: row.art_id,
      art_img: row.art_img,
      art_imgName: row.art_imgName,
      art_itbm_cod_v: row.art_itbm_cod_v,
      art_itbm_venta: row.art_itbm_venta,
      art_precio: row.art_precio,
      art_precio2: row.art_precio2,
      art_precio3: row.art_precio3,
      art_cpbs_codigo: row.art_cpbs_codigo,
      art_referencia: row.art_referencia,
      art_restaurante: row.art_restaurante,
      art_upc: row.art_upc,
      cat_descripcion: row.cat_descripcion,
      itbm_descripcion: row.itbm_descripcion,
      mar_descripcion: row.mar_descripcion,
      bodegas: response,
    });
    SetOpenDetailItem(true);
  }

  async function fetchArticuloByUpc({ art_upc, barcode, modalItem }) {
    setDataSeries([]);

    var response = await get_articulo_by_code(art_upc, usr_sucursal);
    if (response?.[0] !== undefined) {
      if (response[0].series !== "0") {
        var responseSeries = await get_series_by_articulo({ art_id: response[0].art_id, sucursal: usr_sucursal });
        if (dataFacturaDetalle.length > 0) {
          const x = responseSeries.filter((serie) => serie.ser_vendido === "0" && !dataFacturaDetalle.some((detalle) => detalle.ser_id === serie.ser_id));

          setDataSeries(x);
        } else {
          setDataSeries(responseSeries.filter((serie) => serie.ser_vendido === "0"));
        }
      }
    }

    if (response[0] !== undefined) {
      setFormPrecio({
        art_precio: response[0].art_precio,
        art_precio2: response[0].art_precio2,
        art_precio3: response[0].art_precio3,
      });
      setError_upc("");
      setFormFacturaDetalle({
        ...formFacturaDetalle,
        fcd_articulo: response[0].art_id,
        art_descripcion: response[0].art_descripcion,
        art_upc: response[0].art_upc,
        art_servicio: response[0].art_servicio,
        fcd_precio: response[0].art_precio,
        art_itbm_cod_v: response[0].art_itbm_cod_v,
        art_cpbs_codigo: response[0].art_cpbs_codigo,
        art_itbm_venta: response[0].art_itbm_venta,
        fcd_cantidad: dataCompania.com_existencia_v === "1" ? (Number(response[0].inv_qty) > 0 ? "1" : "0") : "1",
        inv_qty: response[0].inv_qty,
      });
      if (isOpenDetailItem === false) {
        modalItem ? setDetailItems(true) : setDetailItems(false);
        setModalItems(false);
      }

      if (barcode) {
        var flag = false;
        var itbms = 0;
        var cantidad = 0;
        var objItems = dataFacturaDetalle.map((data, i) => {
          if (data.fcd_articulo === response[0].art_id && data.art_descripcion === response[0].art_descripcion) {
            if (response[0].art_precio === data.fcd_precio) {
              cantidad = new Decimal(data.fcd_cantidad).plus(new Decimal(1));
              itbms = new Decimal(cantidad).times(new Decimal(data.fcd_precio)).times(new Decimal(data.art_itbm_venta));
              flag = true;
              data.fcd_cantidad = cantidad;
              data.fcd_itbms = itbms;
              data.fcd_total = new Decimal(cantidad).times(new Decimal(response[0].art_precio)).plus(new Decimal(itbms));
            }
            return data;
          }
          return data;
        });

        if (!flag) {
          itbms = new Decimal(1) * new Decimal(response[0].art_precio) * new Decimal(response[0].art_itbm_venta);
          setOBJFacturaDetalle([
            ...dataFacturaDetalle,
            ...[
              {
                ...{
                  ...formFacturaDetalle,
                  fcd_articulo: response[0].art_id,
                  art_descripcion: response[0].art_descripcion,
                  art_upc: response[0].art_upc,
                  fcd_precio: response[0].art_precio,
                  art_cpbs_codigo: response[0].art_cpbs_codigo,
                  art_itbm_cod_v: response[0].art_itbm_cod_v,
                  art_itbm_venta: response[0].art_itbm_venta,
                  fcd_cantidad: dataCompania.com_existencia_v === "1" ? (Number(response[0].inv_qty) > 0 ? "1" : "0") : "1", //dataCompania.com_existencia_v
                  fcd_itbms: itbms,
                  fcd_total: new Decimal(1).times(new Decimal(response[0].art_precio)).plus(new Decimal(itbms)),
                },
              },
            ],
          ]);
          setdataFacturaLocalStorage({
            dataFacturaDetallePr: {
              dataFacturaDetalle: [
                ...dataFacturaDetalle,
                ...[
                  {
                    ...{
                      ...formFacturaDetalle,
                      fcd_articulo: response[0].art_id,
                      art_descripcion: response[0].art_descripcion,
                      art_upc: response[0].art_upc,
                      fcd_precio: response[0].art_precio,
                      art_cpbs_codigo: response[0].art_cpbs_codigo,
                      art_itbm_cod_v: response[0].art_itbm_cod_v,
                      art_itbm_venta: response[0].art_itbm_venta,
                      fcd_cantidad: dataCompania.com_existencia_v === "1" ? (Number(response[0].inv_qty) > 0 ? "1" : "0") : "1",
                      fcd_itbms: itbms,
                      fcd_total: new Decimal(1).times(new Decimal(response[0].art_precio)).plus(new Decimal(itbms)),
                    },
                  },
                ],
              ],
              formClientes,
              dataListPago,
            },
          });
        } else {
          setOBJFacturaDetalle(objItems);
          setdataFacturaLocalStorage({
            dataFacturaDetallePr: {
              dataFacturaDetalle: objItems,
              formClientes,
              dataListPago,
            },
          });
        }
        setFormFacturaDetalle(STATES_FAC_FACTURA({ staneName: "formFacturaDetalle", usr_id }));
        setError("");
      } else {
        setTimeout(() => {
          inputCantidad.current.focus();
        }, 200);
      }
    } else {
      setError_upc("Articulo no existe : " + art_upc);

      setFormFacturaDetalle(STATES_FAC_FACTURA({ staneName: "formFacturaDetalle", usr_id }));
    }
  }
  async function fetchCompania() {
    setdataCompania_f({
      bod_suc: dataCompania.bod_suc,
      com_nombre: dataCompania.com_nombre,
      com_ruc: dataCompania.com_ruc,
      com_dv: dataCompania.com_dv,
      com_direccion: dataCompania.com_direccion,
      com_telefono: dataCompania.com_telefono,
      com_telefono2: dataCompania.com_telefono2,
      com_email: dataCompania.com_email,
      com_fax: dataCompania.com_fax,
      com_web: dataCompania.com_web,
      com_info_interes: dataCompania.com_info_interes,
    });
    if (dataCompania.count === "0") {
      quitToken();
    }
  }

  async function selectItemFCopia({ data, tipo, print_type }) {
    //tipo 0 => recibo, tipo 1 =>electronica
    var response = await get_list_itemsFactura(data.fac_identificador);
    var responseFpago = await get_frm_pago_imprimir_fac(data.fac_identificador);
    var flagCredito = false;
    var arrayFpago = [];
    var resultmap = responseFpago.find((data, i) => {
      if (data.fcfp_number === "01") {
        flagCredito = true;
        return data;
      }
    });
    if (flagCredito) {
      arrayFpago.push(resultmap);
    }

    COPIA_FACTURA({
      formGarantia,
      dataFac: response,
      dataFpago: flagCredito ? arrayFpago : responseFpago,
      dataCompania,
      dataSelected: data,
      usr_prints: tipo === "1" ? (print_type === "pdf" ? "1" : "2") : "3",
      com_suc_emisor: data.fac_codigo_suc || "0000",
      punto_facturacion: data.fac_punto_facturacion || "001",
    });
    setTimeout(() => {
      setModalCopiaF(false);
    }, 1000);
  }
  async function addPago({ crp_fac_identificador, crp_cliente }) {
    var ObjFPago = [];
    var Objfactura_fpago = [];
    var totalValorRecibido = 0;
    var montoEntregado = 0;
    var recibe_number;
    if (dataListPago.length > 0) {
      dataListPago.map((data, i) => {
        Objfactura_fpago.push({
          fcfp_identificador: crp_fac_identificador,
          fcfp_number: data.list_fpago,
          fcfp_fpago: data.list_fpagoName,
          fcfp_monto: data.list_monto,
          fcfp_unique: crp_fac_identificador + data.list_fpago + "_C" + moment(new Date()).format("mmss"),
          fcfp_sucursal: usr_sucursal,
          fcfp_credito: "1",
        });

        ObjFPago.push({
          formaPagoFact: data.list_fpago,
          descFormaPago: data.list_fpago === "99" ? data.list_fpagoName : null,
          valorCuotaPagada: Number(data.list_monto).toFixed(2),
          descFormaPagoR: data.list_fpagoName,
        });
        montoEntregado = montoEntregado + Number(data.list_monto);
        totalValorRecibido = totalValorRecibido + Number(data.list_monto);
      });

      var body = {
        formPago: {
          crp_fac_identificador: crp_fac_identificador,
          crp_cliente: crp_cliente,
          crp_monto: totalValorRecibido,
          crp_sucursal: usr_sucursal,
          crp_fecha: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        },
        fcfp_factura_fpago: Objfactura_fpago,
      };
      var result = post_crp_credito_pago(body);
      result.then((data) => {
        if (data !== false) {
          recibe_number = data.toString().padStart(10, "0");
          fetchCreditoDetalleIdentificador({ crd_fac_identificador: crp_fac_identificador });
          fetchCreditoPago({ crd_fac_identificador: crp_fac_identificador });
          setTimeout(() => {
            fetchCrCredito();
            fetchCrCreditoDetalle({ crd_cliente: crp_cliente });
            fetchCreditoPagoPrint({ crd_fac_identificador: crp_fac_identificador, recibe_number, crp_fac_identificador, crp_cliente, totalValorRecibido, Objfactura_fpago, ObjFPago, montoEntregado });
          }, 1000);
        }
        return data;
      });
      setFormCredito({
        crp_id: "",
        crp_fac_identificador: "",
        crp_cliente: "",
        crp_monto: "",
        crp_fecha: "",
        crp_status: "",
      });
      setFormDropDownFPago({
        frm_id: "",
        frm_code: "",
        frm_descripcion: "",
      });
      setDataCreditosPago([]);
      setDatalistpago([]);
    }
  }

  useEffect(() => {
    fetchCliente({ is_saving: false });
    fetchFormaPago();
    fetchCompania();
    fetch_list_items();
    fetchMesas({ form: null });
    fetchGarantia();
    fetchReRetencion();
    const interval = setInterval(() => {
      VALIDAR_FACTURAS_HKA();
    }, 120000); //120000
    return () => clearInterval(interval);
  }, []);

  const handleSaveRow = ({ exitEditingMode, row, values }) => {
    if (Number(values.fcd_cantidad) > Number(row.original.inv_qty) && row.original.art_servicio === "0" && dataCompania.com_existencia_v === "1") {
      setError(`Cantidad no puede ser mayor a la existencia: ${row.original.inv_qty}`);
      return;
    }

    if (values.art_descripcion.length > 0 && values.art_upc.length > 0 && values.fcd_precio.length > 0) {
      const item = {
        ...row.original,
        art_upc: row.original.art_upc,
        art_descripcion: values.art_descripcion,
        art_cpbs_codigo: row.original.art_cpbs_codigo,
        art_itbm_venta: row.original.art_itbm_venta,
        art_itbm_cod_v: row.original.art_itbm_cod_v,
        fcd_articulo: row.original.fcd_articulo,
        fcd_cantidad: values.fcd_cantidad,
        fcd_precio: values.fcd_precio,
        inv_qty: row.original.inv_qty,
        art_servicio: row.original.art_servicio,
        fcd_serie: row.original.ser_serie,
        ser_id: row.original.ser_id,
      };

      const itemCalculado = CALCULAR_DESCUENTO_FACTURA(item, values.fcd_descuento_number);
      const nuevoDetalle = [...dataFacturaDetalle];
      nuevoDetalle[row.index] = itemCalculado;
      setOBJFacturaDetalle(nuevoDetalle);
      setdataFacturaLocalStorage({
        dataFacturaDetallePr: {
          dataFacturaDetalle: nuevoDetalle,
          formClientes,
          dataListPago,
        },
      });
      setError("");
      exitEditingMode();
    }
  };

  const APLICAR_DESCUENTO_GLOBAL = (porcentaje) => {
    const descuento = Number(porcentaje);
    if (isNaN(descuento) || descuento < 0 || descuento > 100) {
      setError("El descuento debe estar entre 0% y 100%");
      return;
    }
    if (isNaN(descuento) || descuento === 0) {
      setFormFactura({ ...formFactura, fac_descuento_global: "0" });
    }

    const nuevoDetalle = dataFacturaDetalle.map((item) => {
      return CALCULAR_DESCUENTO_FACTURA(item, porcentaje);
    });

    setOBJFacturaDetalle(nuevoDetalle);
    setdataFacturaLocalStorage({
      dataFacturaDetallePr: {
        dataFacturaDetalle: nuevoDetalle,
        formClientes,
        dataListPago,
      },
    });
    // }

    setError("");
  };

  const handleSaveRowRestaurante = ({ exitEditingMode, row, values }) => {
    if (isResEditing) {
      var body = {
        ordd_id: row.original.ordd_id,
        ordd_cantidad: parseFloat(values.ordd_cantidad),
        ordd_itbms: Number(values.ordd_cantidad) * Number(row.original.ordd_precio) * Number(row.original.art_itbm_venta),
        ordd_total: Number(values.ordd_cantidad) * Number(row.original.ordd_precio) * (1 + Number(row.original.art_itbm_venta)),
      };
      put_orden_detalle(body);
      exitEditingMode();
      setTimeout(() => {
        fetchOrdenes({ res_id: formRestaurante.res_mesa_id, form: formRestaurante });
      }, 1000);
    } else {
      dataOrdenesDetalle[row.index] = values;
      dataOrdenesDetalle[row.index] = {
        art_upc: row.original.art_upc,
        art_descripcion: row.original.art_descripcion,
        art_itbm_venta: row.original.art_itbm_venta,
        ordd_articulo: row.original.ordd_articulo,
        ordd_cantidad: parseFloat(values.ordd_cantidad),
        ordd_itbms: Number(values.ordd_cantidad) * Number(row.original.ordd_precio) * Number(row.original.art_itbm_venta),
        ordd_precio: row.original.ordd_precio,
        ordd_total: Number(values.ordd_cantidad) * Number(row.original.ordd_precio) * (1 + Number(row.original.art_itbm_venta)),
        ordd_descuento: row.original.ordd_descuento,
        ordd_descuento_number: row.original.ordd_descuento_number,
        art_itbm_cod_v: row.original.art_itbm_cod_v,
        co_printer: row.original.co_printer,
        ordd_comanda: row.original.ordd_comanda,
      };
      setDataOrdenesDetalle([...dataOrdenesDetalle]);
      const dataFacturaDesdeOrden = dataOrdenesDetalle.map(CONVERTIR_ORDEN_A_FACTURA);
      setdataFacturaLocalStorage({
        dataFacturaDetallePr: {
          dataFacturaDetalle: dataFacturaDesdeOrden,
          formClientes,
          dataListPago,
        },
      });
      exitEditingMode();
    }
  };
  const handleSelectCliente = (row) => {
    console.log(row);
    setFormClientes({
      ...row,
      re_id: row.re_id === undefined ? "" : row.re_id,
      re_desc: row.re_desc === undefined ? "" : row.re_desc,
      re_porc: row.re_porc === undefined ? "" : row.re_porc,
      re_codigo: row.re_codigo === undefined ? "" : row.re_codigo,
      cli_limitc: (Number(row.cli_limitc) - (Number(row.crd_monto_c) - Number(row.crp_monto_p))).toFixed(2),
    });
    setModalCliente(false);

    if (row.cli_tipo_clienteFE === "04") {
      var datafiltrada = Array.isArray(dataFacturaDetalle) ? dataFacturaDetalle.filter((item) => String(item.art_cpbs_codigo || "").trim().length > 0) : [];
      setOBJFacturaDetalle(datafiltrada);
    }
  };

  const onChangeDropdown = (selectedOptions) => {
    if (selectedOptions.objName === "cliente") {
      setFormDropDownCliente({
        ...formDropDownCliente,
        cli_id: selectedOptions.value,
        cli_nombre: selectedOptions.label,
        cli_ruc: selectedOptions.ruc,
        cli_email: selectedOptions.email,
        cli_dv: selectedOptions.dv,
      });
    } else {
      setFormDropDownFPago({
        ...formDropDownFPago,
        frm_id: selectedOptions.value,
        frm_code: selectedOptions.frm_code,
        frm_descripcion: selectedOptions.label,
      });
    }
    setError("");
  };

  function onChangeFac_detail(event) {
    const { value, name } = event.target;

    let nuevoValor = value;

    if (name === "fcd_cantidad") {
      if (formFacturaDetalle.art_servicio === "0" && dataCompania.com_existencia_v === "1") {
        if (Number(value) > Number(formFacturaDetalle.inv_qty)) {
          nuevoValor = Number(formFacturaDetalle.inv_qty);
          setError_upc("Cantidad disponible: " + formFacturaDetalle.inv_qty);
        }
      }
    }

    setFormFacturaDetalle({
      ...formFacturaDetalle,
      [name]: nuevoValor,
    });

    setError("");
    setErrorCliente("");
    setTimeout(() => {
      setError_upc("");
    }, 2000);
  }
  function setPrecio(art_precio) {
    setFormFacturaDetalle({
      ...formFacturaDetalle,
      fcd_precio: art_precio,
    });
    setAnchorEl(false);
    setTimeout(() => {
      inputCantidad.current.focus();
    }, 200);
  }

  const setDescuento = (cell, descuento) => {};

  const deleteRow = (row) => {
    var value = dataFacturaDetalle.filter((data, i) => {
      if (i !== row.index) return data;
    });
    setOBJFacturaDetalle(value);
    setdataFacturaLocalStorage({
      dataFacturaDetallePr: {
        dataFacturaDetalle: value,
        formClientes,
        dataListPago,
      },
    });
  };

  const checkOrden = ({ row }) => {
    var body = {
      ord_identificador: row.ord_identificador,
      ord_flag: row.ord_flag === "1" ? "0" : "1",
      ord_fecha_procesado: row.ord_flag === "1" ? "0000-00-00 00:00:00" : moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    put_check_orden(body);
    setTimeout(() => {
      fetchOrdenesList();
    }, 1000);
  };

  const deleteOrdenMesa = ({ ord_identificador }) => {
    var body = {
      ord_identificador: ord_identificador,
    };
    put_delete_orden_by_ord(body);
    setTimeout(() => {
      fetchOrdenes({ res_id: formRestaurante.res_mesa_id, form: formRestaurante });
    }, 1000);
  };
  const deleteOrden = ({ row }) => {
    var body = {
      ord_identificador: row.ord_identificador,
    };
    put_delete_orden_by_ord(body);
    setModalOrden(false);
  };

  const deleteRowRestaurant = (row) => {
    if (isResEditing) {
      var body = {
        ordd_id: row.original.ordd_id,
      };
      put_delete_orden_detalle(body);
      setTimeout(() => {
        fetchOrdenes({ res_id: formRestaurante.res_mesa_id, form: formRestaurante });
      }, 1000);
      setFormFactura({ ...formFactura, fac_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS") });
    } else {
      var value = dataOrdenesDetalle.filter((data, i) => {
        if (i !== row.index) return data;
      });
      const dataFacturaDesdeOrden = value.map(CONVERTIR_ORDEN_A_FACTURA);
      setDataOrdenesDetalle(value);
      setdataFacturaLocalStorage({
        dataFacturaDetallePr: {
          dataFacturaDetalle: dataFacturaDesdeOrden,
          formClientes,
          dataListPago,
        },
      });
    }
  };

  function addItemRestaurante(dataItem) {
    var defaultCliente = dataCliente.find((data) => {
      if (data.cli_id === "16") {
        return data;
      }
    });
    setFormClientes(defaultCliente);
    const dataFacturaDesdeOrden = dataOrdenesDetalle.map(CONVERTIR_ORDEN_A_FACTURA);
    var flag = false;
    var itbms = 0;
    var subtotals = 0;
    var cantidad = 0;
    var objItems = dataOrdenesDetalle.map((data, i) => {
      if (data.ordd_articulo === dataItem.art_id && data.art_descripcion === dataItem.art_descripcion && data.ordd_entregado === "1") {
        if (dataItem.art_precio === data.ordd_precio) {
          cantidad = Number(data.ordd_cantidad);

          itbms = Number(cantidad) * Number(data.ordd_precio) * Number(data.art_itbm_venta);
          flag = true;
          data.ordd_cantidad = Number(cantidad);
          data.ordd_itbms = itbms;
          data.ordd_total = Number(cantidad) * Number(dataItem.art_precio) + Number(itbms);
        }
        return data;
      }
      return data;
    });

    if (!flag) {
      subtotals = new Decimal(1).times(new Decimal(dataItem.art_precio));
      itbms = new Decimal(subtotals).times(new Decimal(dataItem.art_itbm_venta));

      const dataFacturaDesdeOrden2 = {
        art_descripcion: dataItem.art_descripcion ?? "",
        art_itbm_cod_v: dataItem.art_itbm_cod_v ?? "",
        art_itbm_venta: dataItem.art_itbm_venta ?? "0.00",
        art_upc: dataItem.art_upc ?? "",
        fcd_art_descripcion: dataItem.art_descripcion ?? "",
        fcd_articulo: dataItem.art_id,
        fcd_cantidad: "1",
        fcd_id: "",
        fcd_itbms: new Decimal(itbms).toFixed(6),
        fcd_precio: new Decimal(dataItem.art_precio || 0),
        fcd_total: Number(1) * Number(dataItem.art_precio) + Number(itbms),
      };
      setdataFacturaLocalStorage({
        dataFacturaDetallePr: {
          dataFacturaDetalle: [...dataFacturaDesdeOrden, ...[{ ...dataFacturaDesdeOrden2, fcd_itbms: itbms, fcd_total: new Decimal(subtotals).plus(new Decimal(itbms)) }]],
          formClientes,
          dataListPago,
        },
      });
      if (isResEditing) {
        var qty_articulo = 1;
        dataOrdenesDetalle.map((data, i) => {
          if (dataItem.art_upc === data.art_upc) {
            qty_articulo = Number(qty_articulo) + 1;
          }
        });
        post_ordd_detalle({
          ordd_identificador: dataOrdenesDetalle[0].ordd_identificador,
          ordd_articulo: dataItem.art_id,
          ordd_precio: dataItem.art_precio,
          ordd_cantidad: "1",
          ordd_art_descripcion: dataItem.art_descripcion,
          ordd_itbms_code: dataItem.art_itbm_cod_v,
          ordd_itbms: new Decimal(itbms).toFixed(6),
          ordd_descuento: "",
          ordd_total: Number(Number(1) * Number(dataItem.art_precio) + Number(itbms)),
          ordd_descuento_number: "",
          ordd_unique: dataOrdenesDetalle[0].ordd_identificador + "_" + dataItem.art_id + qty_articulo,
        });
        setTimeout(() => {
          fetchOrdenes({ res_id: formRestaurante.res_mesa_id, form: formRestaurante });
        }, 1000);
      } else {
        setDataOrdenesDetalle([
          ...dataOrdenesDetalle,
          ...[
            {
              ...{
                co_printer: dataItem.co_printer,
                ordd_articulo: dataItem.art_id,
                art_descripcion: dataItem.art_descripcion,
                art_upc: dataItem.art_upc,
                ordd_precio: dataItem.art_precio,
                art_itbm_cod_v: dataItem.art_itbm_cod_v,
                art_itbm_venta: dataItem.art_itbm_venta,
                ordd_cantidad: "1",
                ordd_itbms: new Decimal(itbms).toFixed(6),
                ordd_total: Number(1) * Number(dataItem.art_precio) + Number(itbms),
                ordd_comanda: "0",
              },
            },
          ],
        ]);
      }
    } else {
      if (isResEditing) {
        var flag = false;
        var qty_articulo = 1;
        dataOrdenesDetalle.map((data, i) => {
          if (dataItem.art_upc === data.art_upc) {
            qty_articulo = Number(qty_articulo) + 1;
            flag = true;
          }
        });

        if (!flag) {
          put_ordd_detalle({
            ordd_identificador: dataOrdenesDetalle[0].ordd_identificador,
            ordd_articulo: dataItem.art_id,
            ordd_cantidad: cantidad,
            ordd_itbms: new Decimal(itbms).toFixed(6),
            ordd_total: Number(cantidad) * Number(dataItem.art_precio) + Number(itbms),
          });
        } else {
          post_ordd_detalle({
            ordd_identificador: dataOrdenesDetalle[0].ordd_identificador,
            ordd_articulo: dataItem.art_id,
            ordd_precio: dataItem.art_precio,
            ordd_cantidad: "1",
            ordd_art_descripcion: dataItem.art_descripcion,
            ordd_itbms_code: dataItem.art_itbm_cod_v,
            ordd_itbms: new Decimal(itbms).toFixed(6),
            ordd_descuento: "",
            ordd_total: Number(Number(1) * Number(dataItem.art_precio) + Number(itbms)),
            ordd_descuento_number: "",
            ordd_unique: dataOrdenesDetalle[0].ordd_identificador + "_" + dataItem.art_id + qty_articulo,
          });
        }

        setTimeout(() => {
          fetchOrdenes({ res_id: formRestaurante.res_mesa_id, form: formRestaurante });
        }, 1000);
      } else {
        setDataOrdenesDetalle(objItems);
      }
    }
    setError("");
  }

  function keyPressCantidad(event) {
    var flag_existencia = true; //false NO, true SI
    if (dataCompania.com_existencia_v === "1") {
      //1 que valide existencia, 0 que no valide
      if (Number(formFacturaDetalle.inv_qty) <= 0) {
        flag_existencia = false;
      }
    }
    if (flag_existencia === false && formFacturaDetalle.art_servicio === "0") {
      setError_upc("Articulo no tiene existencias");
    } else {
      setError_upc("");
      var serieSelected = true;
      if (dataSeries.length > 0) {
        serieSelected = false;
        if (formSerie.length > 0) {
          serieSelected = true;
        }
      }
      if (serieSelected) {
        var flag = false;
        var itbms = 0;
        var subtotal = 0;
        var cantidad = 0;
        var objItems = dataFacturaDetalle.map((data, i) => {
          if (data.fcd_articulo === formFacturaDetalle.fcd_articulo && data.art_descripcion === formFacturaDetalle.art_descripcion) {
            if (formFacturaDetalle.fcd_precio === data.fcd_precio) {
              cantidad = Number(data.fcd_cantidad) + Number(formFacturaDetalle.fcd_cantidad);
              itbms = new Decimal(cantidad).times(new Decimal(data.fcd_precio)).times(new Decimal(data.art_itbm_venta));
              flag = true;
              data.fcd_cantidad = cantidad;
              data.fcd_itbms = itbms;
              data.fcd_total = new Decimal(cantidad).times(new Decimal(formFacturaDetalle.fcd_precio)).plus(new Decimal(itbms));
            }
            return data;
          }
          return data;
        });

        if (!flag) {
          subtotal = new Decimal(formFacturaDetalle.fcd_cantidad).times(new Decimal(formFacturaDetalle.fcd_precio));
          itbms = new Decimal(subtotal).times(new Decimal(formFacturaDetalle.art_itbm_venta));

          setOBJFacturaDetalle([...dataFacturaDetalle, ...[{ ...formFacturaDetalle, fcd_itbms: itbms, fcd_total: new Decimal(subtotal).plus(new Decimal(itbms)).toString() }]]);

          setdataFacturaLocalStorage({
            dataFacturaDetallePr: {
              dataFacturaDetalle: [...dataFacturaDetalle, ...[{ ...formFacturaDetalle, fcd_itbms: itbms, fcd_total: new Decimal(subtotal).plus(new Decimal(itbms)) }]],
              formClientes,
              dataListPago,
            },
          });
        } else {
          setOBJFacturaDetalle(objItems);
          setdataFacturaLocalStorage({
            dataFacturaDetallePr: {
              dataFacturaDetalle: objItems,
              formClientes,
              dataListPago,
            },
          });
        }
        setFormFacturaDetalle(STATES_FAC_FACTURA({ staneName: "formFacturaDetalle", usr_id }));
        setFormSerie([]);
      } else {
        setError_upc("Selecciona la Serie del artículo");
      }
    }
  }

  function handleKeyPress(event) {
    const { value, name } = event.target;
    if (event.key === "Enter" && name === "art_upc") {
      if (error_upc.length > 0) {
        setFormFacturaDetalle({ ...formFacturaDetalle, art_upc: "" });
      }

      fetchArticuloByUpc({ art_upc: value, barcode: false, modalItem: false });
    }
    if (event.key === "Enter" && name === "fcd_cantidad" && formFacturaDetalle.fcd_cantidad.length <= 5) {
      keyPressCantidad();
    }
    setError("");
  }
  const setFormRest = ({ data, form }) => {
    var flag2 = false;
    var ordd_identificador = "";
    var ord_info_comanda = "";
    var ord_para_llevar = "";
    var ord_nombre_mesa = "";
    if (form !== null) {
      data.map((data2) => {
        if (form.res_mesa_selected === data2.ord_mesa && data2.ordd_entregado === "0") {
          ordd_identificador = data2.ordd_identificador;
          ord_info_comanda = data2.ord_info_comanda;
          ord_para_llevar = data2.ord_para_llevar;
          ord_nombre_mesa = data2.ord_nombre_mesa;
          flag2 = true;
        }
        if (form.res_mesa_selected === data2.ord_mesa && data2.ordd_entregado === "1") {
          ordd_identificador = data2.ordd_identificador;
          ord_info_comanda = data2.ord_info_comanda;
          ord_para_llevar = data2.ord_para_llevar;
          ord_nombre_mesa = data2.ord_nombre_mesa;
          flag2 = false;
        }
      });
      setFormRestaurante({ ...form, ord_nombre_mesa: ord_nombre_mesa, ord_info_comanda: ord_info_comanda, ord_para_llevar: ord_para_llevar, current_ord_identificador: ordd_identificador, ordd_entregado: flag2 ? "0" : "1" });
    }
  };

  const onClickNuevaFactura = () => {
    var defaultCliente = dataCliente.find((data) => {
      if (data.cli_id === "16") {
        return data;
      }
    });
    setDataSeries([]);
    setModalPagar(false);
    setDatalistpago([]);
    setOBJFacturaDetalle([]);
    setdataFacturaLocalStorage({ dataFacturaDetallePr: [] });
    setFormDropDownCliente(STATES_FAC_FACTURA({ staneName: "formDropDownCliente", usr_id }));
    setFormFacturaDetalle(STATES_FAC_FACTURA({ staneName: "formFacturaDetalle", usr_id }));
    setFormFactura({
      fac_id: "",
      fac_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS"),
      fac_cliente: "",
      fac_vendedor: usr_id,
      fac_fecha: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      fac_caja: cajaData.caj_id,
      fac_sts: "",
      fac_garantia: "",
      fac_text_invoice: "",
      fac_descuento_global: "",
    });
    setFormDropDownFPago(STATES_FAC_FACTURA({ staneName: "formDropDownFPago", usr_id }));
    setFormListPago(STATES_FAC_FACTURA({ staneName: "formListPago", usr_id }));
    setFormClientes(defaultCliente);
    setError_upc("");
    setError("");
    setErrorAnulacion("");
    setErrorCliente("");
    setFormRestaurante(STATES_FAC_FACTURA({ staneName: "formRestaurante", usr_id }));
    fetch_list_items();
    // fetchCliente({is_saving:false});
  };

  const onClickEntregarOrden = () => {
    //tipo 0 => recibo, tipo 1 =>electronica
    if (formRestaurante.res_mesa_selected > 0 && dataOrdenesDetalle[0] !== undefined) {
      put_entregado_orden({ ordd_identificador: dataOrdenesDetalle[0].ordd_identificador });
      setTimeout(() => {
        fetchOrdenes({ res_id: formRestaurante.res_mesa_id, form: formRestaurante });
      }, 700);
    }
  };
  const onClickGuardarOrden = () => {
    //tipo 0 => recibo, tipo 1 =>electronica
    if (dataFacturaDetalle[0] !== undefined) {
      var defaultCliente = dataCliente.find((data) => {
        if (data.cli_id === "16") {
          return data;
        }
      });
      setModalCocinaEnviado(true);
      GUARDAR_ORDEN_NORMAL({ dataFac: dataFacturaDetalle, formFactura, formOrden: formRestaurante, is_restaurante: false, formClientes, usr_sucursal });
      setTimeout(() => {
        setModalPagar(false);
        setDatalistpago([]);
        setOBJFacturaDetalle([]);
        setdataFacturaLocalStorage({ dataFacturaDetallePr: [] });
        setFormDropDownCliente(STATES_FAC_FACTURA({ staneName: "formDropDownCliente", usr_id }));
        setFormFacturaDetalle(STATES_FAC_FACTURA({ staneName: "formFacturaDetalle", usr_id }));
        setFormFactura({
          fac_id: "",
          fac_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS"),
          fac_cliente: "",
          fac_vendedor: usr_id,
          fac_fecha: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          fac_caja: cajaData.caj_id,
          fac_sts: "",
          fac_garantia: "",
          fac_text_invoice: "",
          fac_descuento_global: "",
        });
        setFormDropDownFPago(STATES_FAC_FACTURA({ staneName: "formDropDownFPago", usr_id }));
        setFormListPago(STATES_FAC_FACTURA({ staneName: "formListPago", usr_id }));
        setFormClientes(defaultCliente);
        setError_upc("");
        setError("");
        setDataSeries([]);
        setErrorAnulacion("");
        setErrorCliente("");
        setModalCocinaEnviado(false);
      }, 3000);
    }
  };
  const printReceipt_cocina = ({ flag_comanda }) => {
    var resultOrdenesDetalle = dataOrdenesDetalle.filter((data) => data.ordd_comanda === "0");
    const impresoras = [...new Set(resultOrdenesDetalle.map((item) => item.co_printer).filter(Boolean))];
    const dataPorImpresora = impresoras.map((printer) => ({
      printer,
      items: resultOrdenesDetalle.filter((item) => item.co_printer === printer),
    }));
    dataPorImpresora.forEach((data) => {
      var body = {
        printer: data.printer,
        dataOrdenesDetalle: data.items,
        dataOrden: formRestaurante,
        ord_info_comanda: formRestaurante.ord_info_comanda !== undefined ? formRestaurante.ord_info_comanda : "",
        ord_para_llevar: formRestaurante.ord_para_llevar !== undefined ? formRestaurante.ord_para_llevar : "",
      };
      print_recibo_cocina({ form: body });
    });
    if (formRestaurante.ord_info_comanda?.length > 0) {
      var bodyy = {
        ordd_identificador: formRestaurante.current_ord_identificador,
        ord_info_comanda: formRestaurante.ord_info_comanda,
      };
      put_comanda_info({ data: bodyy });
    }
    if (formRestaurante.ord_para_llevar?.length > 0) {
      var bodyy2 = {
        ordd_identificador: formRestaurante.current_ord_identificador,
        ord_para_llevar: formRestaurante.ord_para_llevar,
      };
      put_para_llevar({ data: bodyy2 });
    }
    if (flag_comanda) {
      var body = {
        ordd_identificador: formRestaurante.current_ord_identificador,
        ord_info_comanda: formRestaurante.ord_info_comanda,
        ord_para_llevar: formRestaurante.ord_para_llevar,
      };
      put_comanda({ data: body });
      setTimeout(() => {
        fetchOrdenes({ res_id: formRestaurante.res_mesa_id, form: formRestaurante });
      }, 500);
    }
  };

  const onClickGuardarOrdenRestaurante = ({ is_saving }) => {
    //tipo 0 => recibo, tipo 1 =>electronica
    if (formRestaurante.res_mesa_selected > 0 && dataOrdenesDetalle[0] !== undefined) {
      if (is_saving === false) {
        setModalCocinaEnviado(true);
      }
      GUARDAR_ORDEN_RESTAURANTE({ dataFac: dataOrdenesDetalle, formFactura, dataOrden: formRestaurante, is_restaurante: true, usr_sucursal, usr_id });
      setTimeout(() => {
        fetchOrdenes({ res_id: formRestaurante.res_mesa_id, form: formRestaurante });
      }, 1000);

      setTimeout(() => {
        setModalCocinaEnviado(false);
      }, 2000);
    }
  };

  const onClickSaveFacturaPr = ({ tipo, pdf, prefactura }) => {
    //tipo 0 => recibo, tipo 1 =>electronica
    var dataFacturaDesdeOrden;
    if (usr_perfil === "3") {
      dataFacturaDesdeOrden = dataOrdenesDetalle.map((data) => {
        return {
          art_catalogo: data.art_catalogo ?? "0",
          art_cpbs_codigo: data.art_cpbs_codigo ?? null,
          art_descripcion: data.art_descripcion ?? "",
          art_itbm_cod_v: data.art_itbm_cod_v ?? "",
          art_itbm_venta: data.art_itbm_venta ?? "0.00",
          art_servicio: data.art_servicio ?? "0",
          art_upc: data.art_upc ?? "",
          fcd_art_descripcion: data.ordd_art_descripcion ?? "",
          fcd_articulo: data.ordd_articulo ?? "",
          fcd_cantidad: String(data.ordd_cantidad ?? "0"),
          fcd_descuento: data.ordd_descuento === "" || data.ordd_descuento === undefined ? "0" : String(data.ordd_descuento),
          fcd_descuento_number: data.ordd_descuento_number ?? "",
          fcd_id: "",
          fcd_identificador: data.ordd_identificador ?? "",
          fcd_itbms: new Decimal(data.ordd_itbms || 0),
          fcd_itbms_code: data.ordd_itbms_code ?? "",
          fcd_precio: new Decimal(data.ordd_precio || 0),
          fcd_total: new Decimal(data.ordd_total || 0),
          inv_qty: data.inv_qty ?? "0.00",
          ser_id: data.ser_id ?? "",
          ser_serie: data.ser_serie ?? "",
        };
      });
      // setOBJFacturaDetalle(dataFacturaDesdeOrden);
    }
    setLoading(true);
    const formFacturaData = {
      fac_id: "",
      fac_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS"),
      fac_cliente: "",
      fac_vendedor: usr_id,
      fac_fecha: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      fac_caja: cajaData.caj_id,
      fac_sts: "",
      fac_garantia: "",
      fac_text_invoice: "",
      ...(usr_perfil === "3" ? formFactura : {}),
    };
    var dataFactura = dataFacturaDetalle;
    var dataFormFactura = usr_perfil === "3" ? formFacturaData : formFactura;
    const detalleFactura = usr_perfil === "3" ? dataFacturaDesdeOrden : dataFacturaDetalle;
    if (formClientes.cli_id.length > 0 && detalleFactura[0] !== undefined) {
      if (formClientes.cli_exento === "1") {
        dataFacturaDetalle = dataFacturaDetalle.map((data) => ({
          ...data,
          art_itbm_venta: "0.00",
          fcd_itbms: "0.00",
          fcd_total: new Decimal(data.fcd_total).minus(new Decimal(data.fcd_itbms)),
        }));
      }
      GUARDAR_FACTURA({
        formRetencion,
        formGarantia,
        formRestaurante,
        dataFac: usr_perfil === "3" ? dataFacturaDesdeOrden : dataFacturaDetalle,
        dataFpago: dataListPago,
        prefactura,
        dataCompania,
        formFactura: dataFormFactura,
        formDropDownFPago,
        formClientes,
        usr_prints: tipo === "1" ? (pdf ? "1" : "2") : "3",
        usr_sucursal,
        com_suc_emisor,
        punto_facturacion: cajaData.caja_punto_facturacion,
        caj_id: cajaData.caj_id,
        usr_nombre,
      });
      setModalPagar(false);
      setLoading(false);
    } else {
      setError("Campos vacios");
    }
  };

  async function VALIDAR_FACTURAS_HKA() {
    const response = await get_facturas_hka_pendientes({ usr_sucursal });
    for (const factura of response) {
      try {
        await consultar_estadoDocumento({ ...factura, validacionHKA: true });
      } catch (error) {
        console.log("ERROR VALIDANDO FACTURA HKA:", factura.fac_id, error);
      }
    }
  }

  const onClickSaveFactura = ({ tipo, pdf, prefactura }) => {
    const formFacturaData = {
      fac_id: "",
      fac_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS"),
      fac_cliente: "",
      fac_vendedor: usr_id,
      fac_fecha: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      fac_caja: cajaData.caj_id,
      fac_sts: "",
      fac_garantia: "",
      fac_text_invoice: "",
      ...(usr_perfil === "3" ? formFactura : {}),
    };
    var dataFactura = dataFacturaDetalle;
    var dataFormFactura = usr_perfil === "3" ? formFacturaData : formFactura;

    //tipo 0 => recibo, tipo 1 =>electronica
    if (formClientes.cli_id.toString().length > 0 && dataFactura[0] !== undefined) {
      var x = GUARDAR_FACTURA({
        formRetencion,
        formGarantia,
        formRestaurante,
        dataFac: dataFactura,
        dataFpago: dataListPago,
        prefactura,
        dataCompania,
        formFactura: dataFormFactura,
        formDropDownFPago,
        formClientes,
        usr_prints: tipo === "1" ? (pdf ? "1" : "2") : "3",
        usr_sucursal,
        com_suc_emisor,
        punto_facturacion: cajaData.caja_punto_facturacion,
        caj_id: cajaData.caj_id,
        usr_nombre,
      });
      if (!prefactura) {
        setModalEnviado(true);
        setModalPagar(false);
      } else {
        fetchMesas({ form: null });
      }

      x.then((data) => {
        if (Number(data.status) === 200) {
          onClickNuevaFactura();
        } else if (data.pendiente === true) {
          console.warn("Factura pendiente de confirmar con HKA", data.data); // La factura fue guardada localmente, // pero no sabemos si HKA la procesó. // NO generar otra factura automáticamente.
        } else {
          setFormFactura({ ...formFactura, fac_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS") }); // HKA respondió explícitamente con error.// Ya se regresó el inventario.// Podemos generar un nuevo identificador.
        }
      }).catch((error) => {
        console.error("Error inesperado guardando factura:", error);
      });
      setTimeout(() => {
        setModalEnviado(false);
      }, 8000);
    } else {
      setError("Campos vacios");
    }
  };

  async function onClickBuscarRuc({ ruc, is_modal_ruc }) {
    if (ruc.length > 0) {
      var result = await consultar_ruc({ ruc });
      if (is_modal_ruc) {
        if (result.ConsultarRucDVResult.codigo === "200") {
          setDataRuc({
            codigo: result.ConsultarRucDVResult.codigo,
            tipoRuc: result.ConsultarRucDVResult.infoRuc.tipoRuc,
            ruc: result.ConsultarRucDVResult.infoRuc.ruc,
            dv: result.ConsultarRucDVResult.infoRuc.dv,
            razonSocial: result.ConsultarRucDVResult.infoRuc.razonSocial,
            afiliadoFE: result.ConsultarRucDVResult.infoRuc.afiliadoFE,
            mensaje: result.ConsultarRucDVResult.mensaje,
            resultado: result.ConsultarRucDVResult.resultado,
          });
        } else {
          setDataRuc({
            codigo: result.ConsultarRucDVResult.codigo,
            tipoRuc: "",
            ruc: "",
            dv: "",
            razonSocial: "",
            afiliadoFE: "",
            mensaje: result.ConsultarRucDVResult.mensaje,
            resultado: result.ConsultarRucDVResult.resultado,
          });
          setErrorCliente("RUC: " + ruc + " No se encontro resultados");
        }
      } else {
        if (result.ConsultarRucDVResult.codigo === "200") {
          setFormClientes({
            ...formClientes,
            cli_tipo_clienteFE: "01",
            cli_nombre: result.ConsultarRucDVResult.infoRuc.razonSocial,
            cli_tipoContribuyente: result.ConsultarRucDVResult.infoRuc.tipoRuc,
            cli_ruc: result.ConsultarRucDVResult.infoRuc.ruc,
            cli_dv: result.ConsultarRucDVResult.infoRuc.dv,
          });
        } else {
          setFormClientes({ ...formClientes, cli_tipo_clienteFE: "02", cli_nombre: "", cli_tipoContribuyente: "1", cli_ruc: result?.ConsultarRucDVResult?.infoRuc?.ruc ?? "", cli_dv: result?.ConsultarRucDVResult?.infoRuc?.dv ?? "" });
          setErrorCliente("RUC: " + ruc + " No se encontro resultados");
        }
      }
    }
  }

  const nota_credito = ({ tipo, items, print_mode }) => {
    //tipo 0 => recibo, tipo 1 =>electronica
    NC_FACTURA({
      formGarantia,
      dataCompania,
      items,
      formAnulacion,
      formClientes,
      usr_prints: tipo === "1" ? print_mode : "3",
      formDropDownFPago,
      com_suc_emisor: items.factura[0].fac_codigo_suc || "0000",
      usr_sucursal,
      punto_facturacion: items.factura[0].fac_punto_facturacion || "001",
      caj_id: cajaData.caj_id,
    });
    setTimeout(() => {
      setModalCopiaF(false);
      setErrorAnulacion("");
    }, 2000);
  };

  const guardarNombreMesa = ({ ordd_identificador, ord_nombre_mesa }) => {
    var body = {
      ordd_identificador,
      ord_nombre_mesa,
    };
    put_ord_nombre_mesa({ data: body });
    setTimeout(() => {
      fetchOrdenes({ res_id: formRestaurante.res_mesa_id, form: formRestaurante });
    }, 500);
  };

  const onClickAnular = async ({ tipo, print_mode }) => {
    const result = await ANULAR_FACTURA({ formGarantia, usr_sucursal, dataCompania, formAnulacion, formClientes, usr_prints: tipo === "1" ? print_mode : "3", formDropDownFPago, com_suc_emisor: formAnulacion.fac_codigo_suc || "0000", punto_facturacion: formAnulacion.fac_punto_facturacion || "001" });

    if (result.status === false && result.pendiente === false) {
      setErrorAnulacion("Escriba el motivo de la anulación.");
      return;
    }
    if (result.pendiente === true) {
      setErrorAnulacion("No se pudo confirmar la anulación con HKA.");
      return;
    }
    if (Number(result.status) === 200) {
      setModalCopiaF(false);
      setErrorAnulacion("");
    }
  };

  const onClickOpenPagar = () => {
    setModalPagar(true);
    setFormListPago(STATES_FAC_FACTURA({ staneName: "formListPago", usr_id }));
    setFormGarantia({ gr_name: "", gr_descripcion: "" });
    setFormDropDownFPago({
      frm_id: "",
      frm_code: "",
      frm_descripcion: "",
    });
    var limitc = 0;
    dataListPago.find((data, i) => {
      if (data.list_fpago === "01") {
        limitc = data.list_monto;
        return data;
      }
    });
    setFormClientes({ ...formClientes, cli_limitc: Number(formClientes.cli_limitc) + Number(limitc) });
    setDatalistpago([]);
    if (usr_perfil === "3") {
      const dataFacturaDesdeOrden = dataOrdenesDetalle.map((data) => {
        return {
          art_catalogo: data.art_catalogo ?? "0",
          art_cpbs_codigo: data.art_cpbs_codigo ?? null,
          art_descripcion: data.art_descripcion ?? "",
          art_itbm_cod_v: data.art_itbm_cod_v ?? "",
          art_itbm_venta: data.art_itbm_venta ?? "0.00",
          art_servicio: data.art_servicio ?? "0",
          art_upc: data.art_upc ?? "",
          fcd_art_descripcion: data.ordd_art_descripcion ?? "",
          fcd_articulo: data.ordd_articulo ?? "",
          fcd_cantidad: String(data.ordd_cantidad ?? "0"),
          fcd_descuento: data.ordd_descuento === "" || data.ordd_descuento === undefined ? "0" : String(data.ordd_descuento),
          fcd_descuento_number: data.ordd_descuento_number ?? "",
          fcd_id: "",
          fcd_identificador: data.ordd_identificador ?? "",
          fcd_itbms: new Decimal(data.ordd_itbms || 0),
          fcd_itbms_code: data.ordd_itbms_code ?? "",
          fcd_precio: new Decimal(data.ordd_precio || 0),
          fcd_total: new Decimal(data.ordd_total || 0),
          inv_qty: data.inv_qty ?? "0.00",
          ser_id: data.ser_id ?? "",
          ser_serie: data.ser_serie ?? "",
        };
      });
      setOBJFacturaDetalle(dataFacturaDesdeOrden);
    }
  };

  const onClickSaveCliente = () => {
    var body = {
      cli_nombre: formClientes.cli_nombre,
      cli_direccion: formClientes.cli_direccion,
      cli_telefono: formClientes.cli_telefono,
      cli_telefono2: formClientes.cli_telefono2,
      cli_suc: usr_sucursal,
      cli_ruc: formClientes.cli_ruc.trim().toUpperCase(),
      cli_dv: formClientes.cli_dv,
      cli_email: formClientes.cli_email,
      cli_limitc: formClientes.cli_limitc,
      cli_credito: formClientes.cli_credito,
      cli_retencion: formClientes.re_id,
      cli_exento: formClientes.cli_exento,
      cli_tipo_clienteFE: formClientes.cli_tipo_clienteFE === "0" ? "02" : formClientes.cli_tipo_clienteFE,
      cli_tipoContribuyente: formClientes.cli_tipoContribuyente,
      return: false,
    };
    if (formClientes.cli_nombre.length > 0) {
      if (formClientes.cli_email.length > 0) {
        if (validate(formClientes.cli_email)) {
          var result = post_cli_cliente(body);
          result.then((data) => {
            setFormClientes({ ...formClientes, cli_id: data });
          });
          setTimeout(() => {
            fetchCliente({ is_saving: true });
          }, 1000);
        } else {
          setErrorCliente("E-Mail incorrecto");
        }
      } else {
        var result = post_cli_cliente(body);
        result.then((data) => {
          setFormClientes({ ...formClientes, cli_id: data });
        });
        setTimeout(() => {
          fetchCliente({ is_saving: true });
        }, 1000);
      }
    } else {
      setErrorCliente("Campos importantes estan vacios");
    }
  };

  function onChangeAnulacion(event) {
    const { value, name } = event.target;
    setFormAnulacion({
      ...formAnulacion,
      [name]: value,
    });
    setErrorAnulacion("");
  }
  function onChangeRuc(event) {
    const { value, name } = event.target;
    setFormRuc({
      ...formRuc,
      [name]: value,
    });
    setErrorRuc("");
  }

  function onChange(event) {
    const { value, name, type, checked } = event.target;
    let newForm = {
      ...formClientes,
      [name]: type === "checkbox" ? (checked ? "1" : "0") : value,
    };

    if (name === "cli_tipo_clienteFE") {
      if (value === "02") {
        newForm.cli_tipoContribuyente = "1";
      }

      if (value === "04") {
        newForm.cli_tipoContribuyente = "";
      }
    }

    if (name === "cli_tipoContribuyente") {
      if (formClientes.cli_tipo_clienteFE === "02") {
        newForm.cli_tipoContribuyente = "1";
      }

      if (formClientes.cli_tipo_clienteFE === "04") {
        newForm.cli_tipoContribuyente = "";
      }
    }

    setFormClientes(newForm);
    setErrorCliente("");
  }

  function onChangeNumberOrden(event) {
    const { value, name } = event.target;
    setFormRestaurante({
      ...formRestaurante,
      [name]: value,
    });
    setErrorCliente("");
  }
  function onChangePagar(input) {
    setFormListPago({
      ...formListPago,
      list_monto: input,
    });
    setError("");
  }

  function onChangeFac(event) {
    const { value, name } = event.target;
    setFormFactura({
      ...formFactura,
      [name]: value,
    });
    setError("");
  }
  function onChangeFpago(event) {
    const { value, name } = event.target;
    setFormListPago({
      ...formListPago,
      [name]: value,
    });
    setError("");
  }

  const setFormClientesBlank = () => {
    if (dataFacturaDetalle[0] === undefined) {
      setFormClientes(STATES_FAC_FACTURA({ staneName: "formClientes", usr_id }));
    }
  };
  const setAddFPago = () => {
    if (formDropDownFPago.frm_code.length > 0) {
      var flag = false;
      var flagLimitC = false;
      var sum;
      var listMonto = 0;
      sum = dataListPago.map((data) => {
        listMonto = Number(data.list_monto) + Number(formListPago.list_monto);
        if (data.list_fpago === formDropDownFPago.frm_code) {
          flag = true;

          if (formDropDownFPago.frm_code === "01" && formClientes.cli_credito === "1") {
            if (Number(formListPago.list_monto) <= Number(formClientes.cli_limitc)) {
              flagLimitC = true;
              setFormClientes({ ...formClientes, cli_limitc: Number(formClientes.cli_limitc) - Number(formListPago.list_monto) });
            } else {
              flagLimitC = false;
              setError("Monto supera el límite de crédito");
            }
          } else {
            flagLimitC = true;
          }
          if (flagLimitC) {
            return {
              list_identificador: formFactura.fac_identificador,
              list_fpago: formDropDownFPago.frm_code,
              list_fpagoName: formDropDownFPago.frm_descripcion,
              list_monto: listMonto,
            };
          }
        } else {
          if (Number(listMonto) <= Number(formClientes.cli_limitc)) {
            return data;
          }
        }
      });
      if (flag === false) {
        if (formDropDownFPago.frm_code === "01" && formClientes.cli_credito === "1") {
          if (Number(formListPago.list_monto) <= Number(formClientes.cli_limitc)) {
            setFormClientes({ ...formClientes, cli_limitc: Number(formClientes.cli_limitc) - Number(formListPago.list_monto) });
            setDatalistpago([
              ...dataListPago,
              ...[
                {
                  list_identificador: formFactura.fac_identificador,
                  list_fpago: formDropDownFPago.frm_code,
                  list_fpagoName: formDropDownFPago.frm_descripcion,
                  list_monto: Number(formListPago.list_monto),
                },
              ],
            ]);
            setdataFacturaLocalStorage({
              dataFacturaDetallePr: {
                dataFacturaDetalle,
                formClientes,
                dataListPago: [
                  ...dataListPago,
                  ...[
                    {
                      list_identificador: formFactura.fac_identificador,
                      list_fpago: formDropDownFPago.frm_code,
                      list_fpagoName: formDropDownFPago.frm_descripcion,
                      list_monto: Number(formListPago.list_monto),
                    },
                  ],
                ],
              },
            });
          } else {
            setError("Monto supera el límite de crédito");
          }
        } else {
          setdataFacturaLocalStorage({
            dataFacturaDetallePr: {
              dataFacturaDetalle,
              formClientes,
              dataListPago: [
                ...dataListPago,
                ...[
                  {
                    list_identificador: formFactura.fac_identificador,
                    list_fpago: formDropDownFPago.frm_code,
                    list_fpagoName: formDropDownFPago.frm_descripcion,
                    list_monto: Number(formListPago.list_monto),
                  },
                ],
              ],
            },
          });
          setDatalistpago([
            ...dataListPago,
            ...[
              {
                list_identificador: formFactura.fac_identificador,
                list_fpago: formDropDownFPago.frm_code,
                list_fpagoName: formDropDownFPago.frm_descripcion,
                list_monto: Number(formListPago.list_monto),
              },
            ],
          ]);
        }
      } else {
        setDatalistpago(sum);
      }
      setFormListPago(STATES_FAC_FACTURA({ staneName: "formListPago", usr_id }));
      setFormDropDownFPago({
        frm_id: "",
        frm_code: "",
        frm_descripcion: "",
      });
    } else {
      setError("Selecciona la forma de pago");
    }
  };

  const updateUsrIdLocal = (usr_perfil) => {
    setdataFacturaLocalStorage({ dataFacturaDetallePr: [] });
    const tokenActual = reactLocalStorage.getObject("tokenP");
    reactLocalStorage.setObject("tokenP", {
      ...tokenActual,
      usr_perfil,
    });
    window.location.reload();
  };

  const deleteCrePago = (row) => {
    var body = {
      crp_id: row.original.crp_id,
      crp_fecha_delete: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    delete_crp_credito_pago(body);
    setTimeout(() => {
      fetchCreditoPago({ crd_fac_identificador: row.original.crp_fac_identificador });
      fetchCreditoDetalleIdentificador({ crd_fac_identificador: row.original.crp_fac_identificador });
    }, 1000);
  };

  const deleteRowFpago = (row) => {
    if (row.original.list_fpago === "01") {
      setFormClientes({ ...formClientes, cli_limitc: Number(formClientes.cli_limitc) + Number(row.original.list_monto) });
    }
    var value = dataListPago.filter((data, i) => {
      if (i !== row.index) return data;
    });
    setDatalistpago(value);
    setdataFacturaLocalStorage({
      dataFacturaDetallePr: {
        dataFacturaDetalle,
        formClientes,
        dataListPago: value,
      },
    });
  };

  const onClickUpdateClient = () => {
    if (formClientes.cli_id !== "16") {
      if (formClientes.cli_nombre.length > 0) {
        if (formClientes.cli_email.length > 0) {
          if (validate(formClientes.cli_email)) {
            PUT_CLIENTE({ formClientes });
            setTimeout(() => {
              fetchCliente({ is_saving: true });
            }, 1000);
          } else {
            setErrorCliente("E-Mail incorrecto");
          }
        } else {
          PUT_CLIENTE({ formClientes });
          setTimeout(() => {
            fetchCliente({ is_saving: true });
          }, 1000);
        }
      } else {
        setErrorCliente("Campos importantes estan vacios");
      }
    }
  };

  const onClickUpdateCliente_sts = ({ row }) => {
    var body = {
      cli_id: row.cli_id,
      cli_sts: 0,
    };
    var result = put_cli_cliente_sts(body);
    result.then((data) => {
      setError("");
      if (data === true) fetchCliente({ is_saving: true });
      else setError("ERROR " + data);
    });
  };

  function onChangeCredPago(event) {
    const { value, name } = event.target;
    setFormCredito({
      ...formCredito,
      [name]: value,
    });
    setError("");
  }
  const handleOnChangeDate = (ranges) => {
    const { selection } = ranges;
    setOpenFlagCalendar(Number(flagCalendar) + 1);
    setState([selection]);
    if (flagCalendar === 1) {
      fetchReportXResult({ startDate: selection.startDate, endDate: selection.endDate });
      setOpenFlagCalendar(0);
    }
  };

  const handleOnChangeCheckBox = (event) => {
    const { value, name } = event.target;
    setFormClientes({
      ...formClientes,
      [name]: value === "0" ? "1" : "0",
    });
  };

  if (formClientes.cli_exento === "1") {
    dataFacturaDetalle = dataFacturaDetalle.map((data) => ({
      ...data,
      art_itbm_venta: "0.00",
      fcd_itbms: "0.00",
      fcd_total: new Decimal(data.fcd_total).minus(new Decimal(data.fcd_itbms)),
    }));
  }

  const ObjFrmPago = GET_FORMAS_PAGO(dataFormaPago);
  if (formClientes.cli_nombre.length > 0 || dataFacturaDetalle[0] !== undefined) {
    enableTab = false;
  }

  if (usr_perfil === "3" && isModalPagar === false && isModalEnviado === false) {
    dataOrdenesDetalle.forEach((row) => {
      subtotal = subtotal.plus(new Decimal(row.ordd_cantidad).times(row.ordd_precio));
      itbms = itbms.plus(row.ordd_itbms ?? 0);
    });
    total = subtotal.plus(itbms);
  } else {
    dataFacturaDetalle.forEach((row) => {
      subtotal = subtotal.plus(new Decimal(row.fcd_cantidad).times(row.fcd_precio));
      descuento = descuento.plus(new Decimal(row.fcd_descuento || 0));
      itbms = itbms.plus(row.fcd_itbms ?? 0);
    });
    total = subtotal.plus(itbms);
  }

  subtotal = MONEY_ROUND(subtotal);
  itbms = MONEY_ROUND(itbms);
  total = MONEY_ROUND(total);
  descuento = MONEY_ROUND(descuento);
  var crp_monto = 0;
  var crp_monto_p = 0;
  dataCreditosPago.map((data, i) => {
    crp_monto = Number(crp_monto) + Number(data.crp_monto);
  });

  dataCreditosDetalle.map((data, i) => {
    crp_monto_p = Number(crp_monto_p) + Number(data.crp_monto_p);
  });

  document.getElementsByClassName("css-sghohy-MuiButtonBase-root-MuiButton-root").innerHTML = "Lecciones";
  return (
    <>
      <ToastContainer floatingTime={10000} />
      {usr_perfil === "3" ? (
        <>
          <PantallaMesas
            dataMesas={dataMesas}
            dataCategoria={dataCategoria}
            dataItems={dataItems}
            dataOrdenesDetalle={dataOrdenesDetalle}
            dataCompania={dataCompania}
            formRestaurante={formRestaurante}
            formFactura={formFactura}
            isResEditing={isResEditing}
            enableTab={enableTab}
            usr_precio={usr_precio}
            usr_perfil={usr_perfil}
            subtotal={subtotal}
            itbms={itbms}
            total={total}
            setFormRestaurante={setFormRestaurante}
            setFormFactura={setFormFactura}
            fetchOrdenes={fetchOrdenes}
            addItemRestaurante={addItemRestaurante}
            onClickEntregarOrden={onClickEntregarOrden}
            onClickGuardarOrdenRestaurante={onClickGuardarOrdenRestaurante}
            deleteRowRestaurant={deleteRowRestaurant}
            handleSaveRowRestaurante={handleSaveRowRestaurante}
            DATATABLE_RESTAURANTE={DATATABLE_RESTAURANTE}
            imgURLocalImage={imgURLocalImage}
            LOGO_RESTAURANTE={LOGO_RESTAURANTE}
            formClientes={formClientes}
            formFacturaDetalle={formFacturaDetalle}
            setFormFacturaDetalle={setFormFacturaDetalle}
            usr_id={usr_id}
            setToken={setToken}
            quitToken={quitToken}
            printrecibo_cocina={printReceipt_cocina}
            onChangeNumberOrden={onChangeNumberOrden}
            guardarNombreMesa={guardarNombreMesa}
            onClickOpenPagar={onClickOpenPagar}
            onClickSaveFacturaPr={onClickSaveFacturaPr}
            descuento={descuento}
            deleteOrdenMesa={deleteOrdenMesa}
            fetchReportX={fetchReportX}
            setModalCopiaF={setModalCopiaF}
            fetchListFacImprimir={fetchListFacImprimir}
          />
        </>
      ) : (
        <PantallaFactura
          fetchArticuloByUpc={fetchArticuloByUpc}
          dataItems={dataItems}
          usr_id={usr_id}
          usr_nombre={usr_nombre}
          usr_perfil={usr_perfil}
          usr_modo_tableta={usr_modo_tableta}
          usr_print={usr_print}
          usr_precio={usr_precio}
          dataCompania={dataCompania}
          formClientes={formClientes}
          setFormClientes={setFormClientes}
          dataCliente={dataCliente}
          setModalCliente={setModalCliente}
          setModalAddCliente={setModalAddCliente}
          setBasicModalEditCliente={setBasicModalEditCliente}
          setErrorCliente={setErrorCliente}
          formFactura={formFactura}
          formFacturaDetalle={formFacturaDetalle}
          setFormFacturaDetalle={setFormFacturaDetalle}
          dataFacturaDetalle={dataFacturaDetalle}
          setdataFacturaLocalStorage={setdataFacturaLocalStorage}
          formRestaurante={formRestaurante}
          setFormRestaurante={setFormRestaurante}
          setModalCash={setModalCash}
          setModalNumber={setModalNumber}
          setModalItems={setModalItems}
          onChangeFac_detail={onChangeFac_detail}
          handleKeyPress={handleKeyPress}
          keyPressCantidad={keyPressCantidad}
          inputUpc={inputUpc}
          inputCantidad={inputCantidad}
          enableTab={enableTab}
          dataSeries={dataSeries}
          anchorElSerie={anchorElSerie}
          openSerie={openSerie}
          setAnchorElSerie={setAnchorElSerie}
          handleClickSeries={handleClickSeries}
          setFormSerie={setFormSerie}
          formPrecio={formPrecio}
          anchorEl={anchorEl}
          open={open}
          handleClickPrices={handleClickPrices}
          handleClosePrices={handleClosePrices}
          setPrecio={setPrecio}
          includes_price={includes_price}
          deleteRow={deleteRow}
          handleSaveRow={handleSaveRow}
          setDescuento={setDescuento}
          error={error}
          error_upc={error_upc}
          isAddmodalCliente={isAddmodalCliente}
          onClickNuevaFactura={onClickNuevaFactura}
          onClickGuardarOrden={onClickGuardarOrden}
          onClickOpenPagar={onClickOpenPagar}
          onClickSaveFacturaPr={onClickSaveFacturaPr}
          fetchReportX={fetchReportX}
          setModalAnular={setModalAnular}
          fetchListAnulacion={fetchListAnulacion}
          setErrorAnulacion={setErrorAnulacion}
          setModalCopiaF={setModalCopiaF}
          fetchListFacImprimir={fetchListFacImprimir}
          fetchCotizacionList={fetchCotizacionList}
          setModalCreditos={setModalCreditos}
          fetchCrCredito={fetchCrCredito}
          fetchOrdenesList={fetchOrdenesList}
          setModalRuc={setModalRuc}
          setFormRuc={setFormRuc}
          setDataRuc={setDataRuc}
          updateUsrIdLocal={updateUsrIdLocal}
          subtotal={subtotal}
          itbms={itbms}
          total={total}
        />
      )}
      {isModalCliente && (
        <ListaClienteModal
          dataCliente={dataCliente}
          isOpen={isModalCliente}
          toggle={setModalCliente}
          selectCliente={handleSelectCliente}
          setModalAddCliente={setModalAddCliente}
          setErrorCliente={setErrorCliente}
          setFormClientes={setFormClientes}
          usr_id={usr_id}
          delete_cliente={onClickUpdateCliente_sts}
        />
      )}
      {isAddmodalCliente && (
        <ClienteModal
          props={formClientes}
          isOpen={isAddmodalCliente}
          basicModalEdit={basicModalEditCliente}
          toggle={setModalAddCliente}
          toggleSave={onClickSaveCliente}
          toggleSaveEdit={onClickUpdateClient}
          onChange={onChange}
          error={errorCliente}
          setFormClientesBlank={setFormClientesBlank}
          handleOnChangeCheckBox={handleOnChangeCheckBox}
          setFormRetencion={setFormRetencion}
          setFormClientes={setFormClientes}
          dataRetencion={dataRetencion}
          onClickBuscarRuc={onClickBuscarRuc}
        />
      )}
      {isModalAnular && (
        <AnulacionModal
          dataListAnulacion={dataListAnulacion}
          formAnulacion={formAnulacion}
          isOpen={isModalAnular}
          toggle={setModalAnular}
          onChange={onChangeAnulacion}
          setFormAnulacion={setFormAnulacion}
          toggleSave={onClickAnular}
          nota_credito={nota_credito}
          errorAnulacion={errorAnulacion}
          usr_print={usr_print}
        />
      )}
      {isAddmodalItems && (
        <ListaItemModal
          props={dataItems}
          usr_a_costo={usr_a_costo}
          isOpen={isAddmodalItems}
          toggle={setModalItems}
          selectItem={fetchArticuloByUpc}
          isDetailItem={isDetailItem}
          select_detail_articulo={select_detail_articulo}
          isDetailOpen={isOpenDetailItem}
          formDetailItem={formDetailItem}
          SetOpenDetailItem={SetOpenDetailItem}
          formClientes={formClientes}
        />
      )}
      {isModalCopiaF && (
        <ListaFacModal
          dataListAnulacion={dataListAnulacion}
          onChangeAnulacion={onChangeAnulacion}
          dataListCopia={dataListCopia}
          errorAnulacion={errorAnulacion}
          formAnulacion={formAnulacion}
          isOpen={isModalCopiaF}
          toggle={setModalCopiaF}
          selectItemFCopia={selectItemFCopia}
          usr_print={usr_print}
          setFormAnulacion={setFormAnulacion}
          toggleSaveAnular={onClickAnular}
          nota_credito={nota_credito}
        />
      )}
      {isModalCreditos && (
        <ListaCreditos
          dataListCreditos={dataCreditos}
          isOpen={isModalCreditos}
          toggle={setModalCreditos}
          selectCreditosDetalle={fetchCrCreditoDetalle}
          dataListCreditoDetalle={dataCreditosDetalle}
          dataListCreditoPago={dataCreditosPago}
          selectCreditosPago={fetchCreditoPago}
          onChangeCredPago={onChangeCredPago}
          formCredito={formCredito}
          addPago={addPago}
          crp_monto={crp_monto}
          deleteCrePago={deleteCrePago}
          crp_monto_p={crp_monto_p}
          printAbono={fetchCreditoPagoPrintCopia}
          ObjFrmPago={ObjFrmPago}
          onChangeDropdown={onChangeDropdown}
          formDropDownFPago={formDropDownFPago}
          onChange={onChangeFpago}
          formListPago={formListPago}
          setAddFPago={setAddFPago}
          dataListpago={dataListPago}
          setDatalistpago={setDatalistpago}
          deleteRow={deleteRow}
          setFormDropDownFPago={setFormDropDownFPago}
          setFormListPago={setFormListPago}
          deleteRowFpago={deleteRowFpago}
          setFormPagoCredito={setFormPagoCredito}
          formPagoCredito={formPagoCredito}
          printFac={selectItemFCopia}
          dataBodyCredito={dataBodyCredito}
          dataCompania_f={dataCompania_f}
          isPrinting={isPrinting}
          setPrintI={setPrintI}
        />
      )}
      {isModalPagar && (
        <PagarModal
          deleteRow={deleteRowFpago}
          setDatalistpago={setDatalistpago}
          formDropDownFPago={formDropDownFPago}
          setAddFPago={setAddFPago}
          onChangeDropdown={onChangeDropdown}
          dataListpago={dataListPago}
          formListPago={formListPago}
          ObjFrmPago={ObjFrmPago}
          isOpen={isModalPagar}
          toggle={setModalPagar}
          toggleSave={onClickSaveFactura}
          toggleSavePr={onClickSaveFacturaPr}
          onChange={onChangeFpago}
          total={total - descuento}
          descuento={descuento}
          subtotal={subtotal}
          error={error}
          formClientes={formClientes}
          setFormClientes={setFormClientes}
          loading={loading}
          usr_perfil={usr_perfil}
          usr_print={usr_print}
          setdataCompania={setdataCompania_f}
          dataGarantia={dataGarantia}
          formGarantia={formGarantia}
          setFormGarantia={setFormGarantia}
          onChangePagar={onChangePagar}
          dataRetencion={dataRetencion}
          setFormRetencion={setFormRetencion}
          formRetencion={formRetencion}
          dataFacturaDetalle={dataFacturaDetalle}
          formFactura={formFactura}
          onChangeFac={onChangeFac}
          setFormListPago={setFormListPago}
          APLICAR_DESCUENTO_GLOBAL={APLICAR_DESCUENTO_GLOBAL}
          isEdit={basicModalEditCliente}
          onClickBuscarRuc={onClickBuscarRuc}
          onChangeCliente={onChange}
          toggleSaveEdit={onClickUpdateClient}
        />
      )}
      {isModalEnviadoCocina && <EnviadoCocinaModal isOpen={isModalEnviadoCocina} toggle={setModalCocinaEnviado} />}
      {isModalEnviado && <EnviadoModal isOpen={isModalEnviado} toggle={setModalEnviado} dataListpago={dataListPago} total={total} itbms={itbms} descuento={descuento} />}
      {isOpenReporteZ && <ModalReporteZ isOpen={isOpenReporteZ} toggle={SetOpenReporteZ} props={dataReporteZ} state={state} handleOnChangeDate={handleOnChangeDate} printReceipt={printReportX} usr_print={usr_print} />}
      {isModaCashDrawer && <OPENCASHDRAWERModal formRestaurante={formRestaurante} isOpen={isModaCashDrawer} toggle={setModalCash} onChange={onChangeNumberOrden} openCash={openCashDrawer} code={dataCompania.com_code_caja} />}
      {isModalNumber && <NUMEROModal formRestaurante={formRestaurante} isOpen={isModalNumber} toggle={setModalNumber} onChange={onChangeNumberOrden} print_prefactura={onClickSaveFacturaPr} />}
      {isModalRuc && <RucModal formRuc={formRuc} isOpen={isModalRuc} toggle={setModalRuc} onChange={onChangeRuc} setFormRuc={setFormRuc} onClickBuscarRuc={onClickBuscarRuc} errorRuc={errorRuc} dataRuc={dataRuc} />}
      {isModalOrden && <ListaOrden dataListOrdenes={dataListOrden} isOpen={isModalOrden} toggle={setModalOrden} checkOrden={checkOrden} selectItemOrdenes={fetchOrdenByIdentificador} usr_perfil={usr_perfil} deleteRow={deleteOrden} />}
      {isModalCotizacion && <ListaCotizacion dataListCotizacion={dataListCotizacion} isOpen={isModalCotizacion} toggle={setModalCotizacion} selectItemCotizacion={fetchCotizacionByIdentificador} />}
    </>
  );
};
